import { Card, Typography } from '@mui/material';

export default function WarningDisplay({ message }) {
    return (
        <Card sx={{ bgcolor: 'error.light', p: 0.5, mb: 0.5 }}>
            <Typography variant="body1" sx={{ color: 'white.main', fontWeight: 'bold', textAlign: 'center' }}>{message}</Typography>
        </Card>
    )
}